import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table table-bordered" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_layout = _resolveComponent("content-layout")!

  return (_openBlock(), _createBlock(_component_content_layout, null, {
    header: _withCtx(() => [
      _renderSlot(_ctx.$slots, "header")
    ]),
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "operation"),
      _createElementVNode("table", _hoisted_1, [
        _createElementVNode("thead", null, [
          _renderSlot(_ctx.$slots, "table-header")
        ]),
        _createElementVNode("tbody", null, [
          _renderSlot(_ctx.$slots, "table-body")
        ])
      ])
    ]),
    _: 3
  }))
}